import React from 'react';
import PropTypes from 'prop-types';
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";

const ViewPending = (props) => {
	const {pending} = props;

	return (<Dialog open={true}>
			<DialogTitle id="alert-dialog-title">Pending PokéStop Submission</DialogTitle>
			<DialogContent>
				A PokéStop submission was added to this cell
				{' ' + pending.days_ago.toFixed(1)} days ago by <b>{pending.username}</b>.
			</DialogContent>
			<DialogActions>
				<Button onClick={props.onClose}>
					Close
				</Button>
			</DialogActions>
		</Dialog>);
};

ViewPending.propTypes = {
	onClose: PropTypes.func.isRequired,
	pending: PropTypes.object.isRequired,
};


export default ViewPending;